import Vue from 'vue'
import Topic from '../views/Topic.vue'

Vue.config.productionTip = false

import VueResource from 'vue-resource'
Vue.use(VueResource)

new Vue({
  render: h => h(Topic)
}).$mount('#app')
